import Vue from 'vue';
import storage from '~js/storage';

export default {
  install: function(Vue, opcoes) {
    Vue.prototype.$storage = Vue.storage = storage;
  }
}



// WEBPACK FOOTER //
// ./FrontEnd/plugins/storage.js